import { useState } from 'react';

export type WorkflowReportCellRenderState = {
  showHistory: boolean;
  showChanges: boolean;
};

export type UseWorkflowReportCellRenderTogglesOutput = {
  cellRenderState: WorkflowReportCellRenderState;
  onCellRenderStateChange: (newState: WorkflowReportCellRenderState) => void;
};

export const useWorkflowReportCellRenderToggles =
  (): UseWorkflowReportCellRenderTogglesOutput => {
    const [cellRenderState, setCellRenderState] =
      useState<WorkflowReportCellRenderState>({
        showChanges: false,
        showHistory: false,
      });

    return {
      cellRenderState,
      onCellRenderStateChange: setCellRenderState,
    };
  };
